<template>
  <main class="feedback-page iso-container">
    <h1 class="iso-section-title">{{ $t('nav.feedback') }}</h1>
    <p class="feedback-desc">{{ $t('feedback.description') }}</p>
    <div class="feedback-card iso-card">
      <FeedbackForm />
    </div>
  </main>
</template>

<script setup lang="ts">
import FeedbackForm from '@/components/FeedbackForm.vue'
</script>

<style scoped>
.feedback-page {
  padding-top: calc(var(--header-height) + 32px);
  padding-bottom: 48px;
  max-width: 640px;
}

.feedback-desc {
  color: var(--iso-text-dim);
  font-size: 14px;
  margin-bottom: 24px;
  line-height: 1.7;
}

.feedback-card {
  padding: 32px;
}
</style>
